module.exports = __webpack_public_path__ + "img/selected7-min.f03a6983.png";